import { Fragment, h } from 'preact'
import { signal } from '@preact/signals'
import { useLayoutEffect } from 'preact/hooks'
import { isEmptyObject, isMobile } from '../../js/modules/utilities.js'
import { attachClampByQuery } from '../../js/modules/clamp.js'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'
import Glide from '@glidejs/glide'

export const newsState = signal('')

var newsEventsMenu = {}
var sliders = {}

var autopromo = {}

export const News = (props) => {
   if (isEmptyObject(sliders)) {
      if (isMobile()) {
         sliders = {
            'o-news-actu': {},
            'o-news-media1': {},
            'o-news-sport': {},
         }
      } else {
         sliders = {
            'o-news-actu': {},
            'o-news-sport': {},
            'o-news-focus': {},
            'o-news-media1': {},
            'o-news-media2': {},
            'o-news-media3': {},
         }
      }
   }

   if (newsState.value !== '' && newsState.value['newsEventsMenu'] !== undefined) newsEventsMenu = newsState.value['newsEventsMenu']
   if (newsState.value !== '' && newsState.value['o-news-actu'] !== undefined) sliders['o-news-actu'] = newsState.value['o-news-actu']
   if (!isMobile() && newsState.value !== '' && newsState.value['o-news-focus'] !== undefined) sliders['o-news-focus'] = newsState.value['o-news-focus']
   if (newsState.value !== '' && newsState.value['o-news-sport'] !== undefined) sliders['o-news-sport'] = newsState.value['o-news-sport']
   if (newsState.value !== '' && newsState.value['o-news-media1'] !== undefined) sliders['o-news-media1'] = newsState.value['o-news-media1']
   if (newsState.value !== '' && newsState.value['o-news-media2'] !== undefined) sliders['o-news-media2'] = newsState.value['o-news-media2']
   if (!isMobile() && newsState.value !== '' && newsState.value['o-news-media3'] !== undefined) sliders['o-news-media3'] = newsState.value['o-news-media3']
   if (newsState.value !== '' && newsState.value['newsAutopromo'] !== undefined) autopromo = newsState.value['newsAutopromo']

   return isMobile() ? <NewsMobile {...props} /> : <NewsDesktop {...props} />
}

const isSliderDataFull = () => {
   let result = true
   for (const [key, value] of Object.entries(sliders)) {
      if (isEmptyObject(value)) result = false
   }
   return result
}

const sliderFormater = () => {
   let result = []
   for (const [key, value] of Object.entries(sliders)) {
      value.name = key
      result.push(value)
   }
   return result
}

const NewsDesktop = ({ title, menu, allNewsCTA, position, publicite }) => {
   const refZVoirPlus = '{"track_refZ":"acc-digital_hp_news_voir-plus"}'
   const refZVoirMoins = '{"track_refZ":"acc-digital_hp_news_voir-moins"}'

   // deplier les news si position === 1 - demande pour le back to school
   useLayoutEffect(() => {
      if (position === 1) {
         document.addEventListener('sseEndOfTransmition', () => {
            voirPlusMoins()
         })
      }
   }, [position])

   const voirPlusMoins = () => {

      document.querySelectorAll('.moreNews').forEach((el, idx, arr) => {
         if (el.classList.contains('jsIsHidden')) {
            el.classList.remove('jsIsHidden')
         } else {
            el.classList.add('jsIsHidden')
            if (idx === arr.length - 1) {
               // remonter au niveau de l'element id "oNews"
               const oNewsElement = document.getElementById('oNews')
               if (oNewsElement) {
                  window.scrollTo({
                     top: oNewsElement.getBoundingClientRect().top + window.scrollY - 100
                  })
               }
            }
         }
      })

      window.mediaSliders.forEach((s) => {
         s.update()
      })

      attachClampByQuery('.o-media [data-clamp-line]')
      setAllToMaxHeight('.js-news-line0')
      setAllToMaxHeight('.js-news-line1')
      setAllToMaxHeight('.js-news-line2')
   }

   return (
      <div class={`container-fluid ${position === 1 ? 'mt-2' : ''}`}>
         <div class="row o-news mt-1" id="oNews" data-testid="bande-news">
            <div class="col-6 col-lg-8 js-onews-left">
               <div class="row">
                  <div class="col-12 d-flex align-items-baseline onews-menu" data-testid="news-menu">
                     <Titre {...title} />
                     {!isEmptyObject(newsEventsMenu) ? <Menu {...menu} events={newsEventsMenu.menu.events} cacheKey={newsEventsMenu.cacheKey} /> : ''}
                  </div>

                  <div class="col-12">
                     <h2 class="sr-only">Les News du jour</h2>
                  </div>

                  {isSliderDataFull() ? sliderFormater().map((item, index) => <SliderDesktop {...item} adsId={publicite.nativeAdsId} index={index} />) : null}
               </div>
            </div>

            <div id="totemColumn" class="col-6 col-lg-4 totemColumn position-relative">
               <div class="totemContent">
                  <div class="totemBackground">
                     {!isEmptyObject(publicite) ? <PubliciteDesktop {...publicite} /> : null}
                  </div>
               </div>
            </div>
         </div>

         <div class="col-12 mb-3 d-flex justify-content-center js-onews-left-cta moreNews jsIsHidden">
            <a
               href={allNewsCTA.URL}
               class="btn btn-secondary"
               data-testid="news-voir-toutes"
               data-oevent-category={allNewsCTA.analytics.oeventCategory}
               data-oevent-action={allNewsCTA.analytics.oeventAction}
               data-oevent-label={allNewsCTA.analytics.oeventLabel}
               data-oevent-other={allNewsCTA.analytics.oeventOther}
            >
               {allNewsCTA.label}
            </a>
         </div>

         <div class="col-12 mb-3 d-flex justify-content-center js-onews-left-cta moreNews linkLine">
            <button
               class="o-link-arrow down collapsed mt-0 mt-0"
               data-oevent-category="news_voir-plus"
               data-oevent-action="voir-plus-de-news"
               data-oevent-label="ouverture"
               data-oevent-other={refZVoirPlus}
               onClick={voirPlusMoins}
            >
               Voir plus de News (6)
            </button>
         </div>

         <div class="col-12 mb-3 d-flex justify-content-center js-onews-left-cta moreNews linkLine  jsIsHidden">
            <button
               class="o-link-arrow up collapsed mt-0 mt-0"
               data-oevent-category="news_voir-moins"
               data-oevent-action="voir-moins-de-news"
               data-oevent-label="fermeture"
               data-oevent-other={refZVoirMoins}
               onClick={voirPlusMoins}
            >
               Voir moins de News (2)
            </button>
         </div>
      </div>
   )
}

const NewsMobile = ({ publicite, allNewsCTA, position }) => {
   return (
      <div class={`container-fluid ${position === 1 ? 'mt-2' : ''}`}>
         <div class="row o-news" id="oNews" data-testid="bande-news">
            <div class="col-12">
               <h2 class="mb-1">News</h2>
            </div>

            {isSliderDataFull() ? sliderFormater().map((item) => <SliderMobile {...item} />) : null}

            {!isEmptyObject(publicite) ? <PubliciteMobile {...publicite} /> : null}
         </div>

         <div class="row">
            <div class='col-12 mb-2 d-flex justify-content-center'>
               <a
                  href={allNewsCTA.URL}
                  class="btn btn-secondary"
                  data-testid="news-voir-toutes"
                  data-oevent-category={allNewsCTA.analytics.oeventCategory}
                  data-oevent-action={allNewsCTA.analytics.oeventAction}
                  data-oevent-label={allNewsCTA.analytics.oeventLabel}
                  data-oevent-other={allNewsCTA.analytics.oeventOther}
               >
                  {allNewsCTA.label}
               </a>
            </div>

            <div class="col-12 col-md">
               <div class="news-rm">
                  <div id={publicite.rmAdsId}></div>
               </div>
            </div>
         </div>
      </div>
   )
}

const Titre = ({ URL, analytics, label }) => {
   return (
      <div class="h2 no-signature mr-2 mb-1">
         <a
            href={URL}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            {label}
         </a>
      </div>
   )
}

const Menu = ({ text, events, cacheKey }) => {
   return (
      <nav class="w-100" role="navigation" aria-label="News">
         <ul class="block-title overflow-hidden mb-0 block-title__fixed" id="oNews_menu">
            {text.map((data, index) => (
               <li class="block-title-item d-none d-lg-inline-block" data-testid={`news-menu-text${index}`}>
                  <a
                     href={data.URL}
                     class="title"
                     data-oevent-category={data.analytics.oeventCategory}
                     data-oevent-action={data.analytics.oeventAction}
                     data-oevent-label={data.analytics.oeventLabel}
                     data-oevent-other={data.analytics.oeventOther}
                  >
                     {data.label}
                  </a>
               </li>
            ))}
            {events.map((data) => (
               <li class="block-title-item d-inline-block" data-testid="news-menu-icon" data-cache-key={cacheKey}>
                  <a
                     href={data.URL}
                     class="title"
                     title={data.title}
                     target={data.target}
                     data-oevent-category={data.analytics.oeventCategory}
                     data-oevent-action={data.analytics.oeventAction}
                     data-oevent-label={data.analytics.oeventLabel}
                     data-oevent-other={data.analytics.oeventOther}
                     data-pdb-zid={data.analytics.pdbZid}
                     data-pdb-sc={data.analytics.pdbSc}
                     data-pdb-idc={data.analytics.pdbIdc}
                     data-pdb-vi={data.analytics.pdbVi}
                  >
                     {data.image === '' ? data.title : <img loading="lazy" src={data.image} alt={data.alt} />}
                  </a>
               </li>
            ))}
         </ul>
      </nav>
   )
}

const PubliciteDesktop = ({ nativeAdsId, rmAdsId }) => {
   useLayoutEffect(() => { }, [])

   return (
      <Fragment>
         {/* Pub Autopromo advise */}
         {!isEmptyObject(autopromo) ? <OccasionnelONews {...autopromo} /> : null}

         {/* Pub RM adgateway */}
         {rmAdsId !== '' ? <div id={rmAdsId} class="tag-rm"></div> : null}
      </Fragment>
   )
}

const OccasionnelONews = ({ URL, alt, image, analytics }) => {
   return (
      <div id="zone_news_foisonnement-b" class="foisonnement-onews" data-testid="zone-foisonnement-b">
         <a
            href={URL}
            class="d-block"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-pdb-ta={analytics.pdbTa}
            data-adv-canal={analytics.advCanal}
            data-adv-cappingdata={analytics.advCappingdata}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <picture>
               <source srcset={`${image}?format=480x310&saveas=webp`} media="(max-width: 1199px)" />
               <img src={`${image}?crop=480,310,0,39&saveas=webp`} alt={alt} loading="lazy" />
            </picture>
         </a>
      </div>
   )
}

const PubliciteMobile = ({ nativeAdsId }) => {
   return (
      <div class="col-12 col-sm-6 mb-1">
         <div class="tuile o-media-mobile d-none native-news-container">
            <a href="#" title="" class="onews-reference native-news-link w-100">
               <div class="main-wrapper">
                  <div class="wrapper">
                     <div>
                        <img loading="lazy" alt="" class="image native-news-picture" />
                     </div>
                  </div>
                  <div class="wrapper text-secondary js-news-thumb native-news-wrapper-content position-relative">
                     <h3 class="category standard text-gray3 d-block py-0 my-0 text-truncate native-news-category"></h3>
                     <strong data-clamp-line="3" class="title lead font-weight-bold m-0 native-news-title"></strong>
                  </div>
               </div>
            </a>
         </div>
         <div id={nativeAdsId} widget-id="CRMB_2"></div>
      </div>
   )
}

const SliderDesktop = ({ items, name, title, cacheKey, adsId, index }) => {
   useLayoutEffect(() => {
      if (isSliderDataFull()) mediaGlideInit()
   }, [])

   const getAdsId = (name, index, adsId) => {
      let returnedAdsId = null
      if (name === 'o-news-sport') {
         if (index === 1) returnedAdsId = { id: adsId[0], 'widget-id': 'SF_2' }
      }
      return returnedAdsId
   }

   return (
      <div class={`col-12 col-lg-6 ${index === 2 || index === 3 || index === 4 || index === 5 ? 'jsIsHidden moreNews' : ''}`} data-cache-key={cacheKey}>
         {title !== '' ? <h3 class="sr-only">{title}</h3> : ''}
         <div class={`tuile mb-2 o-media glide glide-slider ${name} ${name === 'o-news-focus' ? 'native-news-container' : ''}`} data-testid={`news-slider-${name}`}>
            <div class="glide__track" data-glide-el="track">
               <ul class="glide__slides">
                  {items.map((item, index) => (
                     <VignetteDesktop {...item} index={index + 1} nbItems={items.length} name={name} adsId={getAdsId(name, index, adsId)} />
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const VignetteDesktop = ({ category, URL, title, target, image, analytics, index, nbItems, navigation, name, adsId }) => {
   // Permet d'ajuster la hauteur des vignettes entre les carrousels adjacent horizontalement
   let newsline = '0'
   if (name === 'o-news-actu' || name === 'o-news-focus') newsline = '1'
   else if (name === 'o-news-sport' || name === 'o-news-media1') newsline = '2'

   return (
      <li class="glide__slide slick-slide" {...adsId}>
         <div
            class="onews-reference lien-composite"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <div class="pt-1">
               <div class="wrapper bg-gray2 pb-1 mr-1">
                  <picture class="ml-1 mt--1 mr--1 wrapper-image w-100">
                     <source srcset={`${image}?saveas=webp&format=435x`} media="(max-width: 959px)" />
                     <source srcset={`${image}?saveas=webp&format=345x`} media="(max-width: 1199px)" />
                     <img loading="lazy" src={`${image}?saveas=webp&format=420x`} alt="" aria-hidden="true" class=" image w-100" />
                  </picture>
               </div>
               <div class={`wrapper bg-gray2 px-1 pb-1 mr-1 text-secondary js-news-line${newsline}`} data-sameheight-active="(min-width: 960px)">
                  <span class="category standard font-weight-bold text-gray3 d-block py-0 my-0">{category}</span>
                  <a href={URL} target={target}>
                     <h4 data-clamp-line="2" class="title lead font-weight-bold m-0 pb-0">
                        {title}
                     </h4>
                  </a>
                  <div class="pagination-news" data-glide-el="controls" aria-hidden="true">
                     <span
                        class="prev-news icon-arrow-previous"
                        title={navigation.previous.title}
                        data-glide-dir="<"
                        data-oevent-category={navigation.previous.analytics.oeventCategory}
                        data-oevent-action={navigation.previous.analytics.oeventAction}
                        data-oevent-label={navigation.previous.analytics.oeventLabel}
                        data-oevent-other={navigation.previous.analytics.oeventOther}
                     ></span>
                     <div class="paging">
                        <strong>{index}</strong> / {nbItems}
                     </div>
                     <span
                        class="next-news icon-arrow-next"
                        title={navigation.previous.title}
                        data-glide-dir=">"
                        data-oevent-category={navigation.next.analytics.oeventCategory}
                        data-oevent-action={navigation.next.analytics.oeventAction}
                        data-oevent-label={navigation.next.analytics.oeventLabel}
                        data-oevent-other={navigation.next.analytics.oeventOther}
                     ></span>
                  </div>
               </div>
            </div>
         </div>
      </li>
   )
}

const SliderMobile = ({ items, title, name, cacheKey }) => {
   useLayoutEffect(() => {
      if (isSliderDataFull()) mediaMobileGlideInit()
   }, [])

   return (
      <div class="col-12 col-sm-6 mb-1" data-cache-key={cacheKey}>
         {title !== '' ? <h3 class="sr-only">{title}</h3> : ''}
         <div class={`tuile o-media-mobile glide glide-slider ${name}`} data-testid={`news-slider-${name}`}>
            <div class="glide__track" data-glide-el="track">
               <ul class="glide__slides">
                  {items.map((item, index) => (
                     <VignetteMobile {...item} index={index + 1} nbItems={items.length} />
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const VignetteMobile = ({ category, URL, title, target, image, analytics }) => {
   return (
      <li class="glide__slide">
         <div
            class="onews-reference lien-composite"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <div class="main-wrapper">
               <div class="wrapper">
                  <picture>
                     <source srcset={`${image}?saveas=webp&format=435x`} media="(max-width: 959px)" />
                     <source srcset={`${image}?saveas=webp&format=345x`} media="(max-width: 1199px)" />
                     <img loading="lazy" src={`${image}?saveas=webp&format=420x`} alt="" aria-hidden="true" class="image" />
                  </picture>
               </div>

               <div class="wrapper text-secondary js-news-thumb" data-sameheight-active="(min-width: 480px)">
                  <span class="category standard font-weight-bold text-gray3 d-block py-0 my-0 text-truncate">{category}</span>
                  <a href={URL} target={target}>
                     <h4 data-clamp-line="3" class="title lead font-weight-bold m-0 pb-0">
                        {title}
                     </h4>
                  </a>
               </div>
            </div>
         </div>
      </li>
   )
}

const onResize = function (element, callback) {
   if (!onResize.watchedElementData) {
      onResize.watchedElementData = []

      var checkForChanges = function () {
         onResize.watchedElementData.forEach(function (data) {
            if (data.element.offsetHeight !== data.offsetHeight) {
               data.offsetHeight = data.element.offsetHeight
               data.callback()
            }
         })
      }

      window.addEventListener('resize', checkForChanges)
      // eslint-disable-next-line no-undef
      var observer = new MutationObserver(checkForChanges)
      observer.observe(document.body, {
         attributes: true,
      })
   }

   onResize.watchedElementData.push({
      element: element,
      offsetHeight: element.offsetHeight,
      callback: callback,
   })
}

/**
 * CARROUSELS MEDIA DESKTOP
 */
const mediaGlideInit = () => {
   const sliders = []
   let glideOption = {
      gap: 0,
      animationDuration: 0,
      autoplay: 10000,
   }

   var sliderCounter = 0

   document.querySelectorAll('.glide-slider').forEach((slider) => {
      let glideSlider = new Glide(slider, glideOption)

      // Callback after mount
      glideSlider.on('mount.after', () => {
         sliderCounter++
         if (sliderCounter === 4) {
            // TODO: setTimeout pour regler un souci due au css critique prospect
            setTimeout(function () {
               attachClampByQuery('.o-media [data-clamp-line]')
               setAllToMaxHeight('.js-news-line0')
               setAllToMaxHeight('.js-news-line1')
               setAllToMaxHeight('.js-news-line2')
            }, 0)
         }
      })

      glideSlider.mount()
      sliders.push(glideSlider)
      glideSlider.pause()

      // Déclenchement des sliders suivant l'ordre défini
      const mediaSliderOrder = ['o-news-actu', 'o-news-media1', 'o-news-focus', 'o-news-sport', 'o-news-media2', 'o-news-media3']
      mediaSliderOrder.forEach((sliderName, index) => {
         let startTime = (index + 1) * 2000
         setTimeout(() => {
            if (glideSlider.selector.classList.contains(sliderName)) {
               glideSlider.go('>')
               glideSlider.play()
            }
         }, startTime)

         // ajout evenements pour accessibilité
         if (glideSlider.selector.classList.contains(sliderName)) {
            document.querySelectorAll('.' + sliderName + ' .onews-reference').forEach((el) => {
               el.addEventListener('focusin', (e) => {
                  glideSlider.pause()
                  e.currentTarget.classList.add('focus-within')
                  let slideIndex = Array.prototype.slice.call(el.parentNode.parentNode.children).indexOf(el.parentNode)
                  glideSlider.go('=' + slideIndex).pause()
               })
               el.addEventListener('focusout', (e) => {
                  e.currentTarget.classList.remove('focus-within')
                  glideSlider.play()
               })
            })
         }
      })
   })
   window.mediaSliders = sliders
}

/**
 * CARROUSELS MEDIA MOBILE
 */
const mediaMobileGlideInit = () => {
   const slidersMobile = []
   let glideOption = {
      gap: 0,
      animationDuration: 200,
      autoplay: 10000,
   }

   document.querySelectorAll('.glide-slider').forEach((slider) => {
      let glideSlider = new Glide(slider, glideOption)

      // Callback after mount
      glideSlider.on('mount.after', () => {
         attachClampByQuery('.o-media-mobile [data-clamp-line]')
         setAllToMaxHeight('.o-media-mobile .js-news-thumb [data-clamp-line]')
      })

      glideSlider.mount()
      slidersMobile.push(glideSlider)
      glideSlider.pause()

      // Déclenchement des sliders suivant l'ordre défini
      const mediaSliderOrder = ['o-news-actu', 'o-news-media1', 'o-news-sport']
      mediaSliderOrder.forEach((sliderName, index) => {
         let startTime = (index + 1) * 2000
         setTimeout(() => {
            if (glideSlider.selector.classList.contains(sliderName)) {
               glideSlider.go('>')
               glideSlider.play()
            }
         }, startTime)
      })
   })
   window.mediaSliders = slidersMobile
}
